import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mr-2 uppercase" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }




export default /*#__PURE__*/_defineComponent({
  __name: 'PriceDisplay',
  props: {
  locale: {
    type: String,
    required: true,
  },
  currency: {
    type: String,
    required: true,
  },
  price: {
    type: Number,
    required: true,
  },
  vat: {
    type: Boolean,
    required: false,
  },
  trainerTax: {
    type: String,
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(Intl.NumberFormat("en-GB", { currency: __props.currency ? __props.currency : "GBP", style: "currency" }).format(__props.price / 100)) + " " + _toDisplayString(__props.currency), 1),
    (__props.vat)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.vat ? _ctx.$t("include-tax") : _ctx.$t("exclude-tax")), 1))
      : _createCommentVNode("", true),
    (__props.trainerTax)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (__props.trainerTax === 'inc')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("include-tax")), 1))
            : _createCommentVNode("", true),
          (__props.trainerTax === 'excl')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("exclude-tax")), 1))
            : _createCommentVNode("", true),
          (__props.trainerTax === 'none')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("tax-free")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})